export interface DefaultResponse<T> {
  data: T[];
}
